import React, { Component } from "react";
import { Checkbox } from "material-ui";

const styles = {
  labelStyle: {
    fontWeight: "300"
  }
};

class CustomFields extends Component {
  static defaultProps = {
    value: {},
    errorText: undefined,
    onChange: () => {},
    onBlur: () => {}
  };

  handleCustomFieldChange = (id, checked) => {
    this.props.onChange(this.props.fieldKey, {
      ...this.props.value,
      [id]: checked
    });
  };

  renderCustomField = () => {
    const self = this;
    const { value } = this.props;
    return this.props.customFields.map(cf => {
      return (
        <div className="col-sm-6 custom-fields-item" key={cf.id}>
          <Checkbox
            label={cf.name}
            checked={value[cf.id] || false}
            onCheck={(e, checked) =>
              self.handleCustomFieldChange(cf.id, checked)
            }
            labelStyle={styles.labelStyle}
          />
        </div>
      );
    });
  };

  render() {
    return (
      <div className="custom-fields-container">
        <p className="custom-fields-description">
          I am interested in learning about Medibank's other insurance products
          as indicated below :
        </p>
        <div className="row">{this.renderCustomField()}</div>
      </div>
    );
  }
}

export { CustomFields };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/FormFields/CustomFields.js